import {Injectable, signal} from '@angular/core';
import {NotificationType, Notification} from '@models/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationService {

  private _notifications = signal<Notification[]>([]);
  notifications = this._notifications.asReadonly();

  show(
    message: string,
    type: NotificationType = 'info',
    duration = 3000
  ) {
    const notification: Notification = {
      id: Date.now().toString(36) + Math.random().toString(36).slice(2),
      message,
      type,
      duration
    };

    this._notifications.update(list => [...list, notification]);

    if (duration > 0) {
      setTimeout(() => this.remove(notification.id), duration);
    }
  }

  success(message: string, duration?: number) {
    this.show(message, 'success', duration);
  }

  error(message: string, duration?: number) {
    this.show(message, 'error', duration);
  }

  info(message: string, duration?: number) {
    this.show(message, 'info', duration);
  }

  warning(message: string, duration?: number) {
    this.show(message, 'warning', duration);
  }

  remove(id: string) {
    this._notifications.update(list =>
      list.filter(n => n.id !== id)
    );
  }
}
